export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var createChatInsightsApi = function (baseUrl, http) {
    var url = baseUrl + "/analytics/chat";
    return {
        getOverview: function (dto) { return http.post(url + "/overview", dto); },
        getNumericComparison: function (dto) { return http.post(url + "/overviewTables/chat", dto); },
        getServedChatsHistogram: function (dto) { return http.post(url + "/servedChats/histogram", dto); },
        getServedChatsCumulative: function (dto) { return http.post(url + "/servedChats/cumulative", dto); },
        getTimeToEndChatHistogram: function (dto) { return http.post(url + "/timeToEndChat/histogram", dto); },
        getTimeToEndChatCumulative: function (dto) { return http.post(url + "/timeToEndChat/cumulative", dto); },
        getNewChatsHistogram: function (dto) { return http.post(url + "/newChats/histogram", dto); },
        getNewChatsCumulative: function (dto) { return http.post(url + "/newChats/cumulative", dto); },
        getFirstResponseTimeHistogram: function (dto) { return http.post(url + "/firstResponseTime/histogram", dto); },
        getFirstResponseTimeCumulative: function (dto) { return http.post(url + "/firstResponseTime/cumulative", dto); },
        getChatRepliesHistogram: function (dto) { return http.post(url + "/chatReplies/histogram", dto); },
        getChatRepliesCumulative: function (dto) { return http.post(url + "/chatReplies/cumulative", dto); },
        getServiceLevelData: function (dto) { return http.post(url + "/chatServiceLevel", dto); },
        getSatisfactionScoreCumulative: function (dto) { return http.post(url + "/satisfactionScore/cumulative", dto); },
        getSatisfactionScoreHistogram: function (dto) { return http.post(url + "/satisfactionScore/histogram", dto); }
    };
};
//# sourceMappingURL=index.js.map